import { useQuery } from "react-query"
import { getTopShows, type TopShowsResponse } from "../requests/topShows"

export function useTopShows(scene: string) {
  return useQuery<TopShowsResponse>(["topShows", scene], () =>
    getTopShows(scene),
  )
}
